@if (tabs.length > 1 && number$ | async) {
    <div class="grid-page mx-sm-4 mt-3">
        <dx-tabs
            keyExpr="key"
            [items]="tabs"
            [selectedItemKeys]="[selectedTab]"
            [iconPosition]="'start'"
            (onItemClick)="selectedTab = $event.itemData.key"
            [scrollByContent]="true"
            [scrollingEnabled]="true"
            [showNavButtons]="false"></dx-tabs>
    </div>
} 

@if (selectedTab === 'details' && showDetails) {
    <app-empty-check-out-details [number]="number$ | async"></app-empty-check-out-details>
} @else if (selectedTab === 'history' && showHistory) {
    <app-empty-check-out-history [number]="number$ | async"></app-empty-check-out-history>
}